<template>
  <v-container class="layout-container">
    <MasterSettings />
  </v-container>
</template>

<script>
import MasterSettings from '@/modules/master/settings/index.vue'
export default {
  components: {
    MasterSettings,
  },
}
</script>
